import { useTheme } from '../../context/ThemeContext';

// Placeholder for the analytical pages we'll build in Phase 4.
const AnalyticsStub = ({ title }) => {
  const { COLORS } = useTheme();

  return (
    <div style={{ padding: '80px 24px', textAlign: 'center', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ fontSize: 44, marginBottom: 14 }}>📊</div>
      <h2 style={{ color: COLORS.text, fontSize: 24, fontWeight: 800, margin: '0 0 8px', letterSpacing: -0.5 }}>{title}</h2>
      <p style={{ color: COLORS.textMuted, fontSize: 14, maxWidth: 420, margin: '0 auto', lineHeight: 1.6 }}>
        Coming in Phase 4 — deeper analysis, complex budgeting, and planning tools.
      </p>
    </div>
  );
};

export default AnalyticsStub;
